/**
 * Created by zuozhuo on 2018/2/9.
 */

import wx from "weixin-js-sdk";
import { signReady } from "./jweixin";
import api from "api/api";
import * as consts from "../consts/consts";
import utils from "./utils";
import storeDebugSettings from "../store/storeDebugSettings";
import debounce from "lodash/debounce";
import { DEFAULT_SHARE_IMAGE } from "../consts/consts";
import { URL_HASH_KEYS } from "../consts/consts";
import bridgeApis from "./bridge/bridgeApis";
import foStorage from "./foStorage";
import semver from "semver";

// 记录已经授权签名的url
let weixinConfigReadyUrl = "";
// 记录首次加载的url
let landingPageUrl;

// 单页应用分享坑
// https://blog.csdn.net/github_37519401/article/details/78406159

// jssdk文档
// https://gitlab.foschool.cn/internal/newdoc/blob/master/wei-xin-xiang-guan/huo-qu-wei-xin-jssdk-qian-ming.md

function debugAlert(...args) {
  if (storeDebugSettings.jssdkDebug) {
    alert(...args);
  }
}

function landingPageReady() {
  return new Promise((resolve, reject) => {
    if (landingPageUrl) {
      setTimeout(() => {
        resolve();
      }, 50);
    } else {
      // 这里进行延迟是为了解决landingPage被redirect的情况, 例如 /front/ 跳转到 /front/home/
      // 还有redirect到login的情况
      setTimeout(() => {
        landingPageUrl = window.location.href;
        resolve();
      }, 300);
    }
  });
}

landingPageReady();

function weixinVersionLargerThan633() {
  var str = window.navigator.userAgent;
  var v0 = [6, 3, 31];
  var regExp = /MicroMessenger\/([\d|\.]+)/;
  if (regExp.exec(str) === null) {
    return;
  }
  var v1 = regExp.exec(str)[1].split(".");
  if (v1.length >= 4) {
    v1 = v1.slice(0, 3);
  }
  v1 = v1.map(function(v) {
    return parseInt(v, 10);
  });
  if (v1[0] > v0[0]) {
    return true;
  }
  if (v1[0] === v0[0] && v1[1] > v0[1]) {
    return true;
  }
  if (v1[0] === v0[0] && v1[1] === v0[1] && v1[2] >= v0[2]) {
    return true;
  }
  return false;
}

function getConfigData(_data) {
  const apiListAll = [
    "checkJsApi",
    "openEnterpriseChat",
    "openEnterpriseContact",
    "onMenuShareTimeline",
    "onMenuShareAppMessage",
    "onMenuShareQQ",
    "onMenuShareWeibo",
    "onMenuShareQZone",
    "startRecord",
    "stopRecord",
    "onVoiceRecordEnd",
    "playVoice",
    "pauseVoice",
    "stopVoice",
    "onVoicePlayEnd",
    "uploadVoice",
    "downloadVoice",
    "chooseImage",
    "previewImage",
    "uploadImage",
    "downloadImage",
    "translateVoice",
    "getNetworkType",
    "openLocation",
    "getLocation",
    "hideOptionMenu",
    "showOptionMenu",
    "hideMenuItems",
    "showMenuItems",
    "hideAllNonBaseMenuItem",
    "showAllNonBaseMenuItem",
    "closeWindow",
    "scanQRCode",
    "getLocalImgData"
  ];
  return {
    debug: storeDebugSettings.jssdkDebug,
    appId: _data.app_id,
    timestamp: _data.timestamp,
    nonceStr: _data.nonce_str,
    signature: _data.signature,
    jsApiList: apiListAll
  };
}

function timeoutResolveReady(resolve) {
  // 安卓ready之后, 必须延迟50以上进行config, 否则分享设置无效???
  let timeout = utils.isAndroid() ? 50 : 50;
  setTimeout(() => {
    resolve(wx);
  }, timeout);
}

function signResolve({ _data, wx, signUrl, resolve }) {
  const configData = getConfigData(_data);

  debugAlert(`wx.config`);
  debugAlert(JSON.stringify(configData));
  wx.config(configData);

  let configFailed = false;

  wx.error(res => {
    configFailed = true;
    weixinConfigReadyUrl = "";
    // console.error(JSON.stringify(res));
    //reject(new Error(JSON.stringify(res)));
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。

    // 因为存在redirect的情况, landingPage不一定是对的, 如/front/重定向到/front/home/
    // if (signUrl !== window.location.href) {
    //   resetLandingPage();
    // }

    debugAlert("微信验证失败");
    debugAlert(JSON.stringify(res));
  });

  wx.ready(() => {
    // 这里为啥要timeout, 因为失败时, error和ready都会触发, 而且变量貌似没有共享, 所以这里延迟, 保证error先触发, 然后判断
    // configFailed失败了, 就不再走成功逻辑
    debugAlert("微信验证成功, configFailed=" + configFailed);
    if (configFailed) {
      return;
    }
    weixinConfigReadyUrl = signUrl;
    timeoutResolveReady(resolve);
  });
}
const signResolveDebounce = utils.debounce(signResolve, 500);

function ready() {
  return landingPageReady().then(() => {
    return new Promise((resolve, reject) => {
      // 非微信环境, 直接ready
      if (!utils.isWeiXin()) {
        timeoutResolveReady(resolve);
        return;
      }

      // 这里要判断一下, 安卓始终要config, 苹果只需要config一次
      if (weixinConfigReadyUrl && utils.isIOS()) {
        debugAlert("已经ready:" + weixinConfigReadyUrl);
        timeoutResolveReady(resolve);
        return;
      }

      if (!utils.isWeiXin()) {
        //reject(new Error("非微信环境, 无法初始化jssdk"));
        // console.error("非微信环境, 无法初始化jssdk");
        timeoutResolveReady(resolve);
        return;
      }

      /*
      把第一次打开的页面叫做进入页；把前端路由若干次跳转（通过pushState/replaceState改变url）之后，当前打开的页面叫做当前页。
      微信验签使用的url（当前网页的URL，不包含#及其后面部分），在Android下取的是当前页url，在IOS下取的是进入页的url（支付目录也是一样）
       */
      /*
      1：安卓微信6.2.7版
      将第一次进入页面的地址保存，之后每次页面改变（即URL变化），就调用一次config。url使用第一次进入页面的URL

      2：安卓微信6.5.7版
      每次URL变化都调用config，但是URL使用当前url

      3：iOS版微信
      只需要进入第一个页面之后调用一次
       */
      // https://blog.csdn.net/github_37519401/article/details/78406159

      let signUrl = window.location.href;

      if (utils.isAndroid()) {
        if (weixinVersionLargerThan633()) {
          signUrl = window.location.href;
        } else {
          signUrl = landingPageUrl;
        }
      }
      if (utils.isIOS()) {
        signUrl = landingPageUrl;
      }

      // 如果当前url已经经过签名了, 那么就不用重复签名
      if (weixinConfigReadyUrl === signUrl) {
        debugAlert("已经签名:" + signUrl);
        timeoutResolveReady(resolve);
        return;
      }

      debugAlert("重新拉取jssdk sign");
      debugAlert(signUrl);

      api.weixinJsSdkSignDebounce(signUrl, ({ data, _data }) => {
        if (data && _data && data.status_code === consts.HTTP_CODE_SUCCESS) {
          signResolveDebounce({ _data, wx, signUrl, resolve });
        }
      });
      //.catch(reject);
    });
  });
}

function addHashToUrl() {
  const newUrl = utils.appendUrlQuery(window.location.href, {
    [URL_HASH_KEYS.JS_SDK_HASH]: new Date().getTime()
  });
  console.log("分享前设置新的url, 带hash: " + newUrl);
  window.history.replaceState({}, document.title, newUrl);
}

function shareBase(options = {}, callback = utils.noop) {
  let {
    title = "测评中心" || document.title,
    desc = "心理测评、交流倾听、咨询预约",
    cover = DEFAULT_SHARE_IMAGE,
    link = utils.appendUrlQuery(window.location.origin, {
      source: utils.getOrganizationWechatAppId(),
      app_id: utils.getWechatAppId()
    }),

    showPopup = false,
    pageName = ""
    // zhugeConfig
  } = options;

  link = utils.ensureAbsoluteUrl(link);

  console.log("准备设置微信分享: 38236163");
  console.log({
    title,
    desc,
    cover,
    link,

    showPopup,
    pageName
    // zhugeConfig
  });

  if (utils.isFoApp()) {
    if (showPopup === undefined) {
      return;
    }

    bridgeApis.setSharePopup({
      // zhugeConfig,
      showPopup,

      title, // 分享标题
      desc, // 分享内容
      cover, // 分享图标
      link // 分享链接
    });

    return;
  }

  return ready().then(wx => {
    doHideMenu();

    console.log("微信jssdk ready: 388243664");
    // 注意, 这里的link必须是当前网页的host, 否则安卓无法分享成功, iOS可以

    // iOS必须更改当前页面的url, 否则无法设置分享参数
    if (utils.isIOS()) {
      addHashToUrl();
    }

    console.log(
      "微信已经配置url: weixinConfigReadyUrl: " + weixinConfigReadyUrl
    );

    // 分享到微信朋友圈
    wx.onMenuShareTimeline({
      title, // 分享标题
      link, // 分享链接
      desc, // 分享描述
      imgUrl: cover,
      success() {
        // 用户确认分享后执行的回调函数
        // dplusShareResult('分享到朋友圈成功', pageName);
      },
      cancel() {
        // 用户取消分享后执行的回调函数
      }
    });

    // 分享到微信好友
    wx.onMenuShareAppMessage({
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接
      imgUrl: cover,
      type: "link", // 分享类型,music、video或link，不填默认为link
      dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
      success() {
        // 用户确认分享后执行的回调函数
        // dplusShareResult('发送给朋友成功', pageName);
      },
      cancel() {
        // 用户取消分享后执行的回调函数
      }
    });

    // 分享到qq
    wx.onMenuShareQQ({
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接
      imgUrl: cover,
      success() {
        // 用户确认分享后执行的回调函数
        // dplusShareResult('分享到qq成功', pageName);
      },
      cancel() {
        // 用户取消分享后执行的回调函数
      }
    });

    // 分享到微博
    wx.onMenuShareWeibo({
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接
      imgUrl: cover,
      success() {
        // 用户确认分享后执行的回调函数
        // dplusShareResult('分享到微博成功', pageName);
      },
      cancel() {
        // 用户取消分享后执行的回调函数
      }
    });

    // 分享到qq空间
    wx.onMenuShareQZone({
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接
      imgUrl: cover,
      success() {
        // 用户确认分享后执行的回调函数
        // dplusShareResult('分享到qq空间成功', pageName);
      },
      cancel() {
        // 用户取消分享后执行的回调函数
      }
    });

    console.log("成功设置微信分享");
    console.log({
      title,
      desc,
      cover,
      link,

      showPopup,
      pageName
      // zhugeConfig
    });
    callback();

    doShowMenu();
  });
}
const share = debounce(shareBase, 500);

function doHideMenu() {
  console.log("设置隐藏分享菜单");
  console.log(wx);
  wx.hideMenuItems({
    fail: res => {
      console.log({
        msg: "hideMenuItems:fail",
        href: window.location.href,
        res
      });
    },
    menuList: [
      "menuItem:share:appMessage",
      "menuItem:share:timeline",
      "menuItem:share:qq",
      "menuItem:share:weiboApp",
      "menuItem:favorite",
      "menuItem:share:facebook",
      "menuItem:share:QZone"
    ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
  });
}
function hideMenu() {
  return ready().then(doHideMenu);
}

function doShowMenu() {
  console.log("设置显示分享菜单");
  console.log(wx);
  wx.showMenuItems({
    fail: res => {
      console.log({
        msg: "showMenuItems:fail",
        href: window.location.href,
        res
      });
    },
    menuList: [
      "menuItem:share:appMessage",
      "menuItem:share:timeline",
      "menuItem:share:qq",
      "menuItem:share:weiboApp",
      "menuItem:favorite",
      "menuItem:share:facebook",
      "menuItem:share:QZone"
    ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
  });
}
function showMenu() {
  return ready().then(doShowMenu);
}

function previewImage({ currentImg, imgList = [] }) {
  if (utils.isFoApp()) {
    bridgeApis.previewImage({ currentImg, imgList });
    return;
  }
  return ready().then(wx => {
    wx.previewImage({
      current: currentImg, // 当前显示图片的http链接
      urls: imgList // 需要预览的图片http链接列表
    });
  });
}

function pay(params) {
  return ready().then(wx => {
    console.log("调用wx进行支付");
    console.log(wx);
    if (!utils.isWeiXin()) {
      utils.toast.info("请在微信下支付");
    }

    return new Promise((resolve, reject) => {
      const paymentParams = {
        ...params,
        // 这里设置了complete后, success将不再触发
        // complete(res) {
        //   console.log(res);
        //   debugAlert("支付完成");
        // },
        // 支付成功后的回调函数
        success(res) {
          console.log("支付成功");
          console.log(res);
          resolve({ success: true });
        },
        cancel(res) {
          console.log("支付取消");
          console.log(res);
          resolve({ success: false, cancel: true });
        }
      };

      wx.chooseWXPay(paymentParams);
    });
  });
}

// 选取图片
function chooseImage({ count = 9, onSuccess = utils.noop }) {
  return signReady().then(() => {
    wx.chooseImage({
      count,
      sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
      success: data => {
        const localIds = data.localIds;

        onSuccess(localIds);
      },
      fail: res => {
        console.log({
          msg: "chooseImage:fail",
          href: window.location.href,
          res
        });
      }
    });
  });
}

// 获取base64格式图片
function getLocalImgData({ localId, onSuccess = utils.noop }) {
  return ready().then(wx => {
    wx.getLocalImgData({
      localId,
      success: res => {
        const { localData } = res;
        onSuccess(localData);
      }
    });
  });
}

function getLocalImgDatas({ localIds, onSuccess = utils.noop }) {
  return signReady().then(() => {
    let i = 0;

    function loadLocalImgData() {
      wx.getLocalImgData({
        localId: localIds[i],
        success: function(res) {
          var localData = res.localData;
          onSuccess(localData);
          i++;

          if (i < localIds.length) {
            loadLocalImgData();
          }
        }
      });
    }

    loadLocalImgData();
  });
}

// 上传图片
function uploadImages({ localIds = [], onSuccess = utils.noop }) {
  if ({}.toString.call(localIds) !== "[object Array]") {
    localIds = [localIds];
  }

  utils.toast.loading("图片上传中");

  return signReady().then(() => {
    let i = 0;

    function getServerId() {
      wx.uploadImage({
        localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 0, // 默认为1，显示进度提示
        success: function(res) {
          onSuccess(res);
          i++;

          if (i < localIds.length) {
            getServerId();
          } else {
            utils.toast.hide();
          }
        }
      });
    }

    getServerId();
  });
}

// 扫码
function scanQRCode({ scanSuccessCallback }) {
  return ready().then(wx => {
    wx.scanQRCode({
      desc: "扫码",
      needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: res => {
        if (typeof scanSuccessCallback === "function") {
          scanSuccessCallback(res);
        }
      }
    });
  });
}

async function setDefaultShare() {
  // const {
  //   data: { data }
  // } = await api.getCompanyInfo();
  // if (data.share_summary || data.logo_url) {
  //   share({
  //     desc: data.share_summary,
  //     cover: data.logo_url
  //   });
  // } else {
  //   share();
  // }
  share({});
}

export default {
  ready,
  share,
  pay,
  hideMenu,
  showMenu,
  chooseImage,
  getLocalImgData,
  previewImage,
  uploadImages,
  getLocalImgDatas,
  scanQRCode,
  setDefaultShare
};



// WEBPACK FOOTER //
// ./src/utils/weixinJsSdk.js